<template>
    <div>
        <HeaderDetailsPage :titulo="titulo" />


        <TabView style="padding-top:60px">
            <TabPanel header="Aulas">
                 <AdicionarCursosNaTurma :turma="parseInt(turma)" :ano="ano" />
            </TabPanel>
            <TabPanel header="Estudantes">
                <AdicionarEstudantesNaTurma :turma="parseInt(turma)" :ano="parseInt(ano)" />
                
            </TabPanel>
        </TabView>

    </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import HeaderDetailsPage from '@/components/layout/HeaderDetailsPage.vue'
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import AdicionarEstudantesNaTurma from '@/components/adm/AdicionarEstudantesNaTurma.vue'
import AdicionarCursosNaTurma from '@/components/adm/AdicionarCursosNaTurma.vue'


const store = useStore();
const route = useRoute();
const router = useRouter();
const titulo = route.query.nome
const turma = route.params.id
const ano = route.query.ano


onMounted(() => {
    store.commit('layout/toggleSidebar', false);

});


onUnmounted(() => {
    store.commit('layout/toggleSidebar', true);
});

function goBack() {
    router.go(-1);
}






</script>
<style>
.p-tabview .p-tabview-nav li .p-tabview-nav-link {
    font-weight: 500;
    font-size: 16px;
    padding: 1rem;
}

</style>